module.exports = __webpack_public_path__ + "img/adv-bird-4.72743fc6.png";